import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/transactionSlice";

import transactionApis from "src/api/transaction";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

// create transaction saga
const CreateTransactionSaga = function* CreateTransactionSaga({
  payload,
}: ReturnType<typeof actions.createTransactionRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      transactionApis.createTransaction,
      payload
    );

    yield put(actions.createTransactionSuccess(response));
  } catch (error) {
    yield put(
      actions.createTransactionError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// get transaction list saga
const GetTransactionsListSaga = function* GetTransactionsListSaga({
  payload,
}: ReturnType<typeof actions.getTransactionListRequest> & {
  payload: { page: number; limit: number };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      transactionApis.getTransactionList,
      payload
    );

    yield put(actions.getTransactionListSuccess(response));
  } catch (error) {
    yield put(
      actions.getTransactionListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// get transaction details saga
const GetTransactionDetailsSaga = function* GetTransactionDetailsSaga({
  payload,
}: ReturnType<typeof actions.getTransactionDetailsRequest> & {
  payload: string;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      transactionApis.getTransactionDetails,
      payload
    );

    yield put(actions.getTransactionDetailsSuccess(response));
  } catch (error) {
    yield put(
      actions.getTransactionDetailsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// edit transaction saga
const EditTransactionSaga = function* EditTransactionSaga({
  payload,
}: ReturnType<typeof actions.editTransactionRequest> & {
  payload: { id: string; data: any };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      transactionApis.editTransaction,
      payload
    );

    yield put(actions.editTransactionSuccess(response));
  } catch (error) {
    yield put(
      actions.editTransactionError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

export default function* tenantSaga() {
  yield all([
    takeEvery(actions.createTransactionRequest, CreateTransactionSaga),
  ]);
  yield all([
    takeEvery(actions.getTransactionListRequest, GetTransactionsListSaga),
  ]);
  yield all([
    takeEvery(actions.getTransactionDetailsRequest, GetTransactionDetailsSaga),
  ]);
  yield all([takeEvery(actions.editTransactionRequest, EditTransactionSaga)]);
}
